import { render, staticRenderFns } from "./AssignmentView.vue?vue&type=template&id=3d24a89f&"
import script from "./AssignmentView.vue?vue&type=script&lang=js&"
export * from "./AssignmentView.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentView.vue?vue&type=style&index=0&id=3d24a89f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports